import { Injectable, EventEmitter } from '@angular/core';
import { User } from '../entities/user.entity';
import { ConfigService } from '../app.config';

@Injectable({
	providedIn: 'root'
  })
export class UserService {

	public userUpdatedSignal: EventEmitter<boolean> = new EventEmitter();
	public userChangeSignal: EventEmitter<string> = new EventEmitter();
	public sessionExpire: number;

	private _data: User;

	private userRoles = { 0: 'regular user', 1: 'admin' };

	public logout(): void {
		this.setAuthToken('');
	}

	public getData() {
		return (!this._data) ? this._data = this.decodeAuthToken(this.authToken): this._data;
	}

	constructor() { }

	public set shouldRemember(shouldRemember: boolean) {
		localStorage.setItem('rememberMe', shouldRemember.toString());
	}

	public get shouldRemember(): boolean {
		return localStorage.getItem('rememberMe') === 'true';
	}

	public get hasToken(): boolean {
		//const token = this.authToken;
		return this.authToken ? true : false;
	}

	public get isTokenValid(): boolean {
		const expireMS = this.sessionExpire * 1000;
		return expireMS > new Date().getTime();
	}

	public setAuthToken(authToken: string): void {
		if (authToken !== '') this._data = this.decodeAuthToken(authToken);
		localStorage.setItem('authToken', authToken);

		//console.log('setAuthToken', this._data);
	}

	public get authToken(): string {
		const authToken = localStorage.getItem('authToken');
		if (!this._data) {
			this._data = this.decodeAuthToken(authToken);
		}
		return authToken;
	}

	// Usuarios: 0 usuario normal, 10 usuario jefe.
	public get isUsers(): boolean {
		if (!this._data || !this._data.rol) return false;
		return this._data.rol === 0 || this._data.rol === 10;
	}

	public get isUser(): boolean {
		if (!this._data || !this._data.rol) return false;
		return this._data.rol === 0;
	}

	public get isJefeUser(): boolean {
		if (!this._data) return false;
		if (!this._data.rol) return false;
		return this._data.rol === 10;
	}

	// Admins: 1 admin normal, 11 super admin.
	public get isAdmins(): boolean {
		if (!this._data || !this._data.rol) return false;
		return this._data.rol === 1 || this._data.rol === 11;
	}

	public get isAdmin(): boolean {
		if (!this._data || !this._data.rol) return false;
		return this._data.rol === 1;
	}

	public get isSuperAdmin(): boolean {
		if (!this._data || !this._data.rol) return false;
		return this._data.rol === 11;
	}

	public getImageWithSize(w: number, h: number, id: string): string {
		return ConfigService.REST_SERVER + '/api/image/user/430/260/' + id + '?rnd=' + Math.floor(Math.random() * 9999999);
	}

	private decodeAuthToken(authToken: string): User {
		if (!authToken || authToken === '') return new User();

		const userData: any = JSON.parse(atob(authToken.split('.')[1]));
		const rs: User = new User();

		if (userData) {
			rs.id = userData._id;
			rs.nombre = userData.nombre;
			rs.apellidos = userData.apellidos;
			rs.email = userData.email;
			rs.cif_nif = userData.cif_nif;
			rs.numCliRivisa = userData.numCliRivisa;
			rs.empresa = userData.empresa;
			rs.rol = userData.rol;
			rs.lastProjects = userData.lastProjects;

			this.sessionExpire = userData.exp;
		}

		return rs;
	}
}
